module.exports = __webpack_public_path__ + "img/twitch-lounge-gal-6.9ba6e914.jpg";